import { Card } from '@sravni/react-design-system/lib/Card';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text, Link } from '@sravni/react-design-system/lib/Typography';
import { ArrowRight } from '@sravni/react-icons';

import styles from '../styles/Offer.module.scss';
import { OfferProps } from '../types/Offer.types';

export const Offer = ({ title, subtitle, color, href, image, onClick, ...rest }: OfferProps) => {
  return (
    <Link href={href} onClick={onClick} className={styles.container} {...rest}>
      <Card size={16} variant="secondary" color={color} className={styles.cardContainer}>
        <Space direction="column" justify="space-between">
          <Space size={8} direction="column">
            <Heading level={4}>{title}</Heading>
            <Text size={14}>{subtitle}</Text>
          </Space>
          <Text className={styles.fakeLink}>
            <Text as="span">Сравнить и выбрать</Text>
            <Icon size={20} icon={<ArrowRight />} className={styles.icon} />
          </Text>
        </Space>
        <div className={styles.imageWrapper}>
          <img src={image} className={styles.image} alt="" />
        </div>
      </Card>
    </Link>
  );
};
